var render = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('div',{staticClass:"tagDiv"},[_c('i',{staticClass:"fas fa-circle",staticStyle:{"font-size":"3px","vertical-align":"middle"}}),_vm._v(" "),_c('small',[_vm._v(_vm._s(_vm.tag))])])}
var staticRenderFns = []

export { render, staticRenderFns }